module.exports = app => {
  const hotloadFile = {
    info: {
      bean: 'hotloadFile',
      title: 'Hotload File',
      persistence: false,
    },
  };
  return hotloadFile;
};
